import { render, staticRenderFns } from "./onIdit.vue?vue&type=template&id=308f05f0"
import script from "./onIdit.vue?vue&type=script&lang=js"
export * from "./onIdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports